$('.js-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.nav-primary').slideToggle();
});

// Sub menu
$(window).resize(function () {
    if (this.resizeTO) clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
        $(this).trigger('windowResize');
    }, 500);
});

$(window).on('load windowResize', function () {
    checkScreenSize();

    function checkScreenSize() {
        var newWindowWidth = $(window).width();
        if (newWindowWidth > 1370) {
            $('.menu-item-has-children').hover(function () {
                const subMenu = jQuery(this).find('.sub-menu')[0];
                $(subMenu).slideToggle();
            });
        }
    }
});



// WEBPACK FOOTER //
// ./scripts/util/menu.js